import React, { useState, useEffect } from "react";

/*Import API helpers */
import { fetchGET } from "../apiHelper";
import {
  dashboardOverview,
  dashboardProjektiPoStatusu,
  dashboardProjektiPoVlogi,
  dashboardProjektiPoClanici,
  dashboardProjektiPoProgramu,
  dashboardProjektiPoLetu,
  dashboardFinancePoClanici,
  dashboardProjektiPoFinanciranju,
  dashboardObcanskaZnanost,
  dashboardZadnjiProjekti,
  dashboardPotekliProjekti,
} from "../listOfApi";

/*React-bootstrap components */
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import ProgressBar from "react-bootstrap/ProgressBar";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge";

/*Bootstrap Icons */
import { 
  BsFolder, 
  BsCheckCircle, 
  BsLightbulb, 
  BsCurrencyEuro,
  BsFileText,
  BsHourglass,
  BsXCircle,
  BsInfoCircle 
} from "react-icons/bs";

const Dashboard = ({ role }) => {
  const [overview, setOverview] = useState(null);
  const [projektiPoStatusu, setProjektiPoStatusu] = useState([]);
  const [projektiPoVlogi, setProjektiPoVlogi] = useState([]);
  const [projektiPoClanici, setProjektiPoClanici] = useState([]);
  const [projektiPoProgramu, setProjektiPoProgramu] = useState([]);
  const [projektiPoLetu, setProjektiPoLetu] = useState([]);
  const [financePoClanici, setFinancePoClanici] = useState([]);
  const [projektiPoFinanciranju, setProjektiPoFinanciranju] = useState([]);
  const [obcanskaZnanost, setObcanskaZnanost] = useState([]);
  const [zadnjiProjekti, setZadnjiProjekti] = useState([]);
  const [potekliProjekti, setPotekliProjekti] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadDashboardData = async () => {
      setIsLoading(true);

      try {
        const [
          overviewData,
          statusData,
          vlogiData,
          claniceData,
          programiData,
          letaData,
          financeData,
          financiranjeData,
          obcanskaData,
          zadnjiData,
          potekliData
        ] = await Promise.all([
          fetchGET(dashboardOverview),
          fetchGET(dashboardProjektiPoStatusu),
          fetchGET(dashboardProjektiPoVlogi),
          fetchGET(dashboardProjektiPoClanici),
          fetchGET(dashboardProjektiPoProgramu),
          fetchGET(dashboardProjektiPoLetu),
          fetchGET(dashboardFinancePoClanici),
          fetchGET(dashboardProjektiPoFinanciranju),
          fetchGET(dashboardObcanskaZnanost),
          fetchGET(dashboardZadnjiProjekti),
          fetchGET(dashboardPotekliProjekti),
        ]);

        console.log("Dashboard API responses:", {
          overviewData,
          statusData,
          vlogiData,
          claniceData,
          programiData,
          letaData,
          financeData,
          financiranjeData,
          obcanskaData,
          zadnjiData,
          potekliData,
        });

        if (overviewData && overviewData !== 0) setOverview(overviewData);
        if (statusData && statusData !== 0) setProjektiPoStatusu(Array.isArray(statusData) ? statusData : []);
        if (vlogiData && vlogiData !== 0) setProjektiPoVlogi(Array.isArray(vlogiData) ? vlogiData : []);
        if (claniceData && claniceData !== 0) setProjektiPoClanici(Array.isArray(claniceData) ? claniceData : []);
        if (programiData && programiData !== 0) setProjektiPoProgramu(Array.isArray(programiData) ? programiData : []);
        if (letaData && letaData !== 0) setProjektiPoLetu(Array.isArray(letaData) ? letaData : []);
        if (financeData && financeData !== 0) setFinancePoClanici(Array.isArray(financeData) ? financeData : []);
        if (financiranjeData && financiranjeData !== 0) setProjektiPoFinanciranju(Array.isArray(financiranjeData) ? financiranjeData : []);
        if (obcanskaData && obcanskaData !== 0) setObcanskaZnanost(Array.isArray(obcanskaData) ? obcanskaData : []);
        if (zadnjiData && zadnjiData !== 0) setZadnjiProjekti(Array.isArray(zadnjiData) ? zadnjiData : []);
        if (potekliData && potekliData !== 0) setPotekliProjekti(Array.isArray(potekliData) ? potekliData : []);
      } catch (error) {
        console.error("Error loading dashboard data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadDashboardData();
  }, []);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("sl-SI", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    }).format(value || 0);
  };

  return (
    <Container fluid>
      <Row>
        <Col className="main-header font-weight-bold">Nadzorna plošča</Col>
      </Row>
      <Row>
        <Col className="header-divider">
          <hr />
        </Col>
      </Row>

      {isLoading && (
        <Row>
          <Col className="text-center py-5">
            <div>Nalaganje podatkov...</div>
          </Col>
        </Row>
      )}

      {!isLoading && overview && (
        <>
          {/* Top Row: Main Statistics */}
          <Row className="mb-4">
            <Col lg={3} md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100" style={{ borderLeft: "4px solid #006a8e" }}>
                <Card.Body className="d-flex align-items-center">
                  <div className="me-3" style={{ fontSize: "2.5rem", color: "#006a8e" }}>
                    <BsFolder />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1" style={{ fontSize: "0.875rem" }}>Skupno projektov</h6>
                    <h2 className="mb-0" style={{ fontWeight: "700" }}>{overview.totalProjects || 0}</h2>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100" style={{ borderLeft: "4px solid #006a8e" }}>
                <Card.Body className="d-flex align-items-center">
                  <div className="me-3" style={{ fontSize: "2.5rem", color: "#006a8e" }}>
                    <BsCheckCircle />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1" style={{ fontSize: "0.875rem" }}>Aktivni projekti</h6>
                    <h2 className="mb-0" style={{ fontWeight: "700" }}>{overview.activeProjects || 0}</h2>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100" style={{ borderLeft: "4px solid #006a8e" }}>
                <Card.Body className="d-flex align-items-center">
                  <div className="me-3" style={{ fontSize: "2.5rem", color: "#006a8e" }}>
                    <BsLightbulb />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1" style={{ fontSize: "0.875rem" }}>Občanska znanost</h6>
                    <h2 className="mb-0" style={{ fontWeight: "700" }}>{overview.citizenScienceProjects || 0}</h2>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100" style={{ borderLeft: "4px solid #006a8e" }}>
                <Card.Body className="d-flex align-items-center">
                  <div className="me-3" style={{ fontSize: "2.5rem", color: "#006a8e" }}>
                    <BsCurrencyEuro />
                  </div>
                  <div>
                    <h6 className="text-muted mb-1" style={{ fontSize: "0.875rem" }}>Načrtovano (UM)</h6>
                    <h2 className="mb-0" style={{ fontWeight: "700", fontSize: "1.5rem" }}>{formatCurrency(overview.totalNacrtovanoUM)} €</h2>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Second Row: Additional Statistics */}
          <Row className="mb-4">
            <Col lg={3} md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100">
                <Card.Body className="d-flex align-items-center justify-content-between">
                  <div>
                    <h6 className="text-muted mb-1" style={{ fontSize: "0.875rem" }}>Osnutki</h6>
                    <h3 className="mb-0" style={{ fontWeight: "600" }}>{overview.draftProjects || 0}</h3>
                  </div>
                  <BsFileText style={{ fontSize: "2rem", color: "#757575" }} />
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100">
                <Card.Body className="d-flex align-items-center justify-content-between">
                  <div>
                    <h6 className="text-muted mb-1" style={{ fontSize: "0.875rem" }}>Prijavljeni</h6>
                    <h3 className="mb-0" style={{ fontWeight: "600" }}>{overview.submittedProjects || 0}</h3>
                  </div>
                  <BsHourglass style={{ fontSize: "2rem", color: "#757575" }} />
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100">
                <Card.Body className="d-flex align-items-center justify-content-between">
                  <div>
                    <h6 className="text-muted mb-1" style={{ fontSize: "0.875rem" }}>Zaključeni</h6>
                    <h3 className="mb-0" style={{ fontWeight: "600" }}>{overview.closedProjects || 0}</h3>
                  </div>
                  <BsCheckCircle style={{ fontSize: "2rem", color: "#757575" }} />
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100">
                <Card.Body className="d-flex align-items-center justify-content-between">
                  <div>
                    <h6 className="text-muted mb-1" style={{ fontSize: "0.875rem" }}>Zavrnjeni</h6>
                    <h3 className="mb-0" style={{ fontWeight: "600" }}>{overview.rejectedProjects || 0}</h3>
                  </div>
                  <BsXCircle style={{ fontSize: "2rem", color: "#757575" }} />
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Finance Row */}
          <Row className="mb-4">
            <Col md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100" style={{ backgroundColor: "#f5f5f5" }}>
                <Card.Body>
                  <div className="d-flex align-items-center mb-2">
                    <BsCurrencyEuro style={{ fontSize: "1.5rem", color: "#006a8e", marginRight: "10px" }} />
                    <h5 className="mb-0" style={{ fontWeight: "600" }}>Načrtovano (UM)</h5>
                  </div>
                  <h2 style={{ fontWeight: "700", color: "#006a8e" }}>{formatCurrency(overview.totalNacrtovanoUM)} €</h2>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className="mb-3">
              <Card className="main-container-card__shadows h-100" style={{ backgroundColor: "#f5f5f5" }}>
                <Card.Body>
                  <div className="d-flex align-items-center mb-2">
                    <BsCurrencyEuro style={{ fontSize: "1.5rem", color: "#525252", marginRight: "10px" }} />
                    <h5 className="mb-0" style={{ fontWeight: "600" }}>Realizirano (UM)</h5>
                  </div>
                  <h2 style={{ fontWeight: "700", color: "#525252" }}>{formatCurrency(overview.totalRealiziranoUM)} €</h2>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Recent Projects - moved up for priority */}
          {zadnjiProjekti.length > 0 && (
            <Row className="mb-4">
              <Col lg={12}>
                <Card className="main-container-card__shadows">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Nedavni projekti</span>
                    <BsInfoCircle 
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }} 
                      title="Zadnjih 10 projektov, ki so bili ustvarjeni ali posodobljeni. Kliknite na projekt za več podrobnosti."
                    />
                  </Card.Header>
                  <Card.Body className="p-0">
                    <Table hover responsive className="mb-0">
                      <thead style={{ backgroundColor: "#fafafa" }}>
                        <tr>
                          <th style={{ width: "40%" }}>Naziv</th>
                          <th style={{ width: "15%" }}>Akronim</th>
                          <th style={{ width: "20%" }}>Status</th>
                          <th style={{ width: "25%" }}>Zadnja sprememba</th>
                        </tr>
                      </thead>
                      <tbody>
                        {zadnjiProjekti.map((project, index) => {
                          // Status badge coloring
                          let badgeVariant = "secondary";
                          const status = (project.status || project.Status || "").toLowerCase();
                          
                          if (status.includes("aktiven") || status.includes("izvajanju")) {
                            badgeVariant = "primary";
                          } else if (status.includes("osnutek") || status.includes("draft")) {
                            badgeVariant = "secondary";
                          } else if (status.includes("prijavljen") || status.includes("submitted")) {
                            badgeVariant = "info";
                          } else if (status.includes("zaključen") || status.includes("closed")) {
                            badgeVariant = "dark";
                          } else if (status.includes("zavrnjen") || status.includes("rejected")) {
                            badgeVariant = "secondary";
                          }
                          
                          // Format timestamp
                          const formatTimestamp = (ts) => {
                            if (!ts) return "-";
                            try {
                              const date = new Date(ts);
                              return date.toLocaleDateString("sl-SI", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit"
                              });
                            } catch {
                              return ts;
                            }
                          };
                          
                          return (
                            <tr key={project.id || project.ID || index} style={{ cursor: "pointer" }}>
                              <td style={{ fontWeight: "500" }}>{project.naziv || project.Naziv || "-"}</td>
                              <td>
                                <code style={{ backgroundColor: "#f5f5f5", padding: "2px 6px", borderRadius: "3px", fontSize: "0.85rem" }}>
                                  {project.akronim || project.Akronim || "-"}
                                </code>
                              </td>
                              <td>
                                <Badge bg={badgeVariant}>
                                  {project.status || project.Status || "-"}
                                </Badge>
                              </td>
                              <td style={{ fontSize: "0.9rem", color: "#666" }}>
                                {formatTimestamp(project.timestamp || project.Timestamp)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* Status Chart */}
          {projektiPoStatusu.length > 0 && (
            <Row className="mb-4">
              <Col lg={12}>
                <Card className="main-container-card__shadows">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Projekti po statusu</span>
                    <BsInfoCircle 
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }} 
                      title="Porazdelitev vseh projektov glede na njihov trenutni status. Prikazuje odstotek projektov v posameznem statusu."
                    />
                  </Card.Header>
                  <Card.Body>
                    {projektiPoStatusu.map((item, index) => {
                      const total = projektiPoStatusu.reduce((sum, p) => sum + (p.value || p.Value || 0), 0);
                      const percentage = total > 0 ? Math.round(((item.value || item.Value || 0) / total) * 100) : 0;
                      
                      // Match status labels to colors
                      let variant = "secondary";
                      const label = (item.label || item.Label || "").toLowerCase();
                      
                      if (label.includes("izvajanju") || label.includes("active")) {
                        variant = "primary";
                      } else if (label.includes("osnutek") || label.includes("draft")) {
                        variant = "secondary";
                      } else if (label.includes("prijavljen") || label.includes("submitted")) {
                        variant = "info";
                      } else if (label.includes("zaključen") || label.includes("closed")) {
                        variant = "dark";
                      } else if (label.includes("zavrnjen") || label.includes("rejected")) {
                        variant = "secondary";
                      }
                      
                      return (
                        <div key={index} className="mb-3">
                          <div className="d-flex justify-content-between mb-2">
                            <span style={{ fontWeight: "500" }}>{item.label || item.Label}</span>
                            <span>
                              <strong>{item.value || item.Value}</strong> <span className="text-muted">({percentage}%)</span>
                            </span>
                          </div>
                          <ProgressBar
                            variant={variant}
                            now={percentage}
                            style={{ height: "25px" }}
                            label={`${percentage}%`}
                          />
                        </div>
                      );
                    })}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* Projects by Role and Faculty */}
          <Row className="mb-4">
            {/* Projekti po vlogi */}
            {projektiPoVlogi.length > 0 && (
              <Col lg={6} className="mb-3">
                <Card className="main-container-card__shadows h-100">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Projekti po vlogi UM</span>
                    <BsInfoCircle 
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }} 
                      title="Razdelitev projektov glede na vlogo Univerze v Mariboru: Koordinator, Partner ali Prijavitelj."
                    />
                  </Card.Header>
                  <Card.Body>
                    {projektiPoVlogi.map((item, index) => {
                      const total = projektiPoVlogi.reduce((sum, p) => sum + (p.value || p.Value || 0), 0);
                      const percentage = total > 0 ? Math.round(((item.value || item.Value || 0) / total) * 100) : 0;
                      
                      // Color coding by role
                      let variant = "primary";
                      const label = (item.label || item.Label || "").toLowerCase();
                      
                      if (label.includes("koordinator")) {
                        variant = "primary";
                      } else if (label.includes("partner")) {
                        variant = "secondary";
                      } else if (label.includes("prijavitelj")) {
                        variant = "info";
                      }
                      
                      return (
                        <div key={index} className="mb-3">
                          <div className="d-flex justify-content-between mb-2">
                            <span style={{ fontWeight: "500" }}>{item.label || item.Label}</span>
                            <span>
                              <strong>{item.value || item.Value}</strong> <span className="text-muted">({percentage}%)</span>
                            </span>
                          </div>
                          <ProgressBar
                            variant={variant}
                            now={percentage}
                            style={{ height: "25px" }}
                            label={`${percentage}%`}
                          />
                        </div>
                      );
                    })}
                  </Card.Body>
                </Card>
              </Col>
            )}

            {/* Projekti po članici */}
            {projektiPoClanici.length > 0 && (
              <Col lg={6} className="mb-3">
                <Card className="main-container-card__shadows h-100">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Projekti po članici (Top 10)</span>
                    <BsInfoCircle 
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }} 
                      title="10 članic Univerze v Mariboru z največ projekti. Prikazuje število projektov za vsako članico."
                    />
                  </Card.Header>
                  <Card.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {projektiPoClanici.slice(0, 10).map((item, index) => {
                      const maxValue = Math.max(...projektiPoClanici.map(p => p.value || p.Value || 0));
                      const percentage = maxValue > 0 ? Math.round(((item.value || item.Value || 0) / maxValue) * 100) : 0;
                      
                      // Generate color gradient based on position
                      const colors = ["#006a8e", "#4a8fa3", "#6fa9b8", "#94c3cd", "#b9dde2"];
                      const colorIndex = Math.min(index % colors.length, colors.length - 1);
                      
                      return (
                        <div key={index} className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <small style={{ fontWeight: "500" }}>{item.label || item.Label}</small>
                            <span>
                              <strong>{item.value || item.Value}</strong>
                            </span>
                          </div>
                          <ProgressBar
                            now={percentage}
                            style={{ height: "20px", backgroundColor: "#e0e0e0" }}
                          >
                            <div
                              style={{
                                width: `${percentage}%`,
                                backgroundColor: colors[colorIndex],
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontWeight: "600",
                                fontSize: "0.875rem"
                              }}
                            >
                              {percentage}%
                            </div>
                          </ProgressBar>
                        </div>
                      );
                    })}
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Row>

          {/* Projects by Program and by Year */}
          <Row className="mb-4">
            {/* Projekti po programu */}
            {projektiPoProgramu.length > 0 && (
              <Col lg={6} className="mb-3">
                <Card className="main-container-card__shadows h-100">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Projekti po programu</span>
                    <BsInfoCircle 
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }} 
                      title="Porazdelitev projektov po glavnih programih financiranja (npr. Horizon Europe, ARRS, Erasmus+)."
                    />
                  </Card.Header>
                  <Card.Body>
                    {projektiPoProgramu.slice(0, 10).map((item, index) => {
                      const maxValue = Math.max(...projektiPoProgramu.map(p => p.value || p.Value || 0));
                      const barHeight = maxValue > 0 ? ((item.value || item.Value || 0) / maxValue) * 100 : 0;
                      
                      // Color palette for programs
                      const colors = ["#006a8e", "#525252", "#757575", "#4a8fa3", "#616161", "#6fa9b8", "#424242", "#78909C"];
                      const color = colors[index % colors.length];
                      
                      return (
                        <div key={index} className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span style={{ fontWeight: "500", fontSize: "0.9rem" }}>{item.label || item.Label}</span>
                            <span>
                              <strong style={{ fontSize: "1.1rem" }}>{item.value || item.Value}</strong>
                            </span>
                          </div>
                          <div style={{ position: "relative", height: "24px", backgroundColor: "#e0e0e0", borderRadius: "4px", overflow: "hidden" }}>
                            <div
                              style={{
                                width: `${barHeight}%`,
                                backgroundColor: color,
                                height: "100%",
                                transition: "width 0.3s ease",
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "8px",
                                color: "white",
                                fontWeight: "600",
                                fontSize: "0.875rem"
                              }}
                            >
                              {barHeight > 15 ? `${Math.round(barHeight)}%` : ''}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Card.Body>
                </Card>
              </Col>
            )}

            {/* Projekti po letu */}
            {projektiPoLetu.length > 0 && (
              <Col lg={6} className="mb-3">
                <Card className="main-container-card__shadows h-100">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Projekti po letih (5 let nazaj / naprej)</span>
                    <BsInfoCircle 
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }} 
                      title="Časovni trend števila projektov za obdobje 5 let nazaj in 5 let naprej od trenutnega leta."
                    />
                  </Card.Header>
                  <Card.Body>
                    <div style={{ position: "relative", height: "300px" }}>
                      {/* Y-axis labels and grid */}
                      <div style={{ display: "flex", height: "100%", alignItems: "flex-end", justifyContent: "space-around", borderBottom: "2px solid #333", paddingBottom: "5px" }}>
                        {(() => {
                          const currentYear = new Date().getFullYear();
                          const filteredData = projektiPoLetu.filter(item => {
                            const year = item.year || item.Year || 0;
                            return year >= currentYear - 5 && year <= currentYear + 5;
                          });
                          
                          const maxCount = Math.max(...filteredData.map(p => p.count || p.Count || 0));
                          
                          return filteredData.map((item, index) => {
                            const barHeight = maxCount > 0 ? ((item.count || item.Count || 0) / maxCount) * 100 : 0;
                            
                            return (
                              <div key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1, marginX: "5px" }}>
                                {/* Bar */}
                                <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", height: "250px", justifyContent: "flex-end" }}>
                                  <div
                                    style={{
                                      width: "70%",
                                      height: `${barHeight}%`,
                                    backgroundColor: "#006a8e",
                                      borderRadius: "4px 4px 0 0",
                                      transition: "height 0.3s ease",
                                      position: "relative",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                    }}
                                    title={`${item.year || item.Year}: ${item.count || item.Count} projektov`}
                                  >
                                    {/* Value label on top of bar */}
                                    <div style={{ 
                                      position: "absolute", 
                                      top: "-20px", 
                                      left: "50%", 
                                      transform: "translateX(-50%)",
                                      fontWeight: "700",
                                      fontSize: "0.9rem",
                                    color: "#006a8e"
                                    }}>
                                      {item.count || item.Count}
                                    </div>
                                  </div>
                                </div>
                                {/* X-axis label */}
                                <div style={{ 
                                  marginTop: "8px", 
                                  fontWeight: "600",
                                  fontSize: "0.9rem",
                                  color: "#555"
                                }}>
                                  {item.year || item.Year}
                                </div>
                              </div>
                            );
                          });
                        })()}
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Row>

          {/* Finance by Faculty */}
          {financePoClanici.length > 0 && (
            <Row className="mb-4">
              <Col lg={12}>
                <Card className="main-container-card__shadows">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Finance po članici - Načrtovano vs. Realizirano (Top 5)</span>
                    <BsInfoCircle 
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }} 
                      title="Primerjava načrtovanih in realiziranih sredstev za top 5 članic. Odstotek realizacije prikazuje, koliko načrtovanih sredstev je bilo dejansko izplačanih."
                    />
                  </Card.Header>
                  <Card.Body>
                    {financePoClanici.slice(0, 5).map((item, index) => {
                      const nacrtovano = item.nacrtovano || item.Nacrtovano || 0;
                      const realizirano = item.realizirano || item.Realizirano || 0;
                      const realizacijaPercentage = nacrtovano > 0 ? Math.round((realizirano / nacrtovano) * 100) : 0;
                      
                      return (
                        <div key={index} className="mb-4" style={{ borderBottom: index < 4 ? "1px solid #e0e0e0" : "none", paddingBottom: "15px" }}>
                          <div className="d-flex justify-content-between mb-2">
                            <span style={{ fontWeight: "600", fontSize: "0.95rem" }}>{item.label || item.Label}</span>
                            <span style={{ fontSize: "0.85rem", color: "#666" }}>
                              Realizacija: <strong style={{ color: realizacijaPercentage >= 80 ? "#006a8e" : realizacijaPercentage >= 50 ? "#757575" : "#525252" }}>{realizacijaPercentage}%</strong>
                            </span>
                          </div>
                          <div className="mb-2">
                            <div className="d-flex justify-content-between mb-1" style={{ fontSize: "0.85rem" }}>
                              <span>Načrtovano</span>
                              <strong style={{ color: "#006a8e" }}>{formatCurrency(nacrtovano)} €</strong>
                            </div>
                            <ProgressBar now={100} variant="secondary" style={{ height: "20px", backgroundColor: "#e0e0e0" }}>
                              <div style={{ width: "100%", backgroundColor: "#006a8e", height: "100%" }} />
                            </ProgressBar>
                          </div>
                          <div>
                            <div className="d-flex justify-content-between mb-1" style={{ fontSize: "0.85rem" }}>
                              <span>Realizirano</span>
                              <strong style={{ color: "#525252" }}>{formatCurrency(realizirano)} €</strong>
                            </div>
                            <ProgressBar now={realizacijaPercentage} style={{ height: "20px", backgroundColor: "#e0e0e0" }}>
                              <div style={{ width: `${realizacijaPercentage}%`, backgroundColor: "#525252", height: "100%" }} />
                            </ProgressBar>
                          </div>
                        </div>
                      );
                    })}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* Potekli projekti */}
          {potekliProjekti.length > 0 && (
            <Row className="mb-4">
              <Col lg={12}>
                <Card className="main-container-card__shadows">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Potekli projekti</span>
                    <BsInfoCircle
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }}
                      title="Projekti, ki so presegli datum konca, a niso formalno zaključeni."
                    />
                  </Card.Header>
                  <Card.Body className="p-0">
                    <Table hover responsive className="mb-0">
                      <thead style={{ backgroundColor: "#fafafa" }}>
                        <tr>
                          <th style={{ width: "35%" }}>Naziv</th>
                          <th style={{ width: "12%" }}>Akronim</th>
                          <th style={{ width: "20%" }}>Status</th>
                          <th style={{ width: "16%" }}>Začetek</th>
                          <th style={{ width: "17%" }}>Konec</th>
                        </tr>
                      </thead>
                      <tbody>
                        {potekliProjekti.map((project, index) => {
                          const formatDate = (dateStr) => {
                            if (!dateStr) return "-";
                            try {
                              return new Date(dateStr).toLocaleDateString("sl-SI", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                              });
                            } catch {
                              return dateStr;
                            }
                          };

                          let badgeVariant = "secondary";
                          const status = (project.status || "").toLowerCase();
                          if (status.includes("izvajanju") || status.includes("aktiven")) {
                            badgeVariant = "primary";
                          } else if (status.includes("prijavljen")) {
                            badgeVariant = "info";
                          } else if (status.includes("zaključen")) {
                            badgeVariant = "dark";
                          }

                          return (
                            <tr key={project.id || index}>
                              <td style={{ fontWeight: "500" }}>{project.naziv || "-"}</td>
                              <td>
                                <code style={{ backgroundColor: "#f5f5f5", padding: "2px 6px", borderRadius: "3px", fontSize: "0.85rem" }}>
                                  {project.akronim || "-"}
                                </code>
                              </td>
                              <td>
                                <Badge bg={badgeVariant}>{project.status || "-"}</Badge>
                              </td>
                              <td style={{ fontSize: "0.9rem", color: "#666" }}>{formatDate(project.zacetek)}</td>
                              <td style={{ fontSize: "0.9rem", color: "#c0392b", fontWeight: "500" }}>{formatDate(project.konec)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* Funding Type and Citizen Science */}
          <Row className="mb-4">
            {/* Projekti po financiranju */}
            {projektiPoFinanciranju.length > 0 && (
              <Col lg={6} className="mb-3">
                <Card className="main-container-card__shadows h-100">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Projekti po tipu financiranja</span>
                    <BsInfoCircle 
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }} 
                      title="Razdelitev projektov glede na vrsto financiranja: javni razpisi, strukturni skladi, tržni projekti itd."
                    />
                  </Card.Header>
                  <Card.Body>
                    {projektiPoFinanciranju.map((item, index) => {
                      const total = projektiPoFinanciranju.reduce((sum, p) => sum + (p.value || p.Value || 0), 0);
                      const percentage = total > 0 ? Math.round(((item.value || item.Value || 0) / total) * 100) : 0;
                      
                      // Color coding by funding type
                      const colors = ["#006a8e", "#525252", "#757575", "#616161", "#424242"];
                      const color = colors[index % colors.length];
                      
                      return (
                        <div key={index} className="mb-3">
                          <div className="d-flex justify-content-between mb-2">
                            <span style={{ fontWeight: "500" }}>{item.label || item.Label}</span>
                            <span>
                              <strong>{item.value || item.Value}</strong> <span className="text-muted">({percentage}%)</span>
                            </span>
                          </div>
                          <ProgressBar
                            now={percentage}
                            style={{ height: "30px", backgroundColor: "#e0e0e0" }}
                          >
                            <div
                              style={{
                                width: `${percentage}%`,
                                backgroundColor: color,
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontWeight: "700",
                                fontSize: "1rem"
                              }}
                            >
                              {percentage}%
                            </div>
                          </ProgressBar>
                        </div>
                      );
                    })}
                  </Card.Body>
                </Card>
              </Col>
            )}

            {/* Občanska znanost */}
            {obcanskaZnanost.length > 0 && (
              <Col lg={6} className="mb-3">
                <Card className="main-container-card__shadows h-100">
                  <Card.Header style={{ backgroundColor: "#f8f9fa", fontWeight: "600", fontSize: "1.1rem" }} className="d-flex justify-content-between align-items-center">
                    <span>Občanska znanost</span>
                    <BsInfoCircle 
                      style={{ fontSize: "1rem", color: "#006a8e", cursor: "help" }} 
                      title="Primerjava projektov, ki vključujejo občansko znanost, z ostalimi projekti."
                    />
                  </Card.Header>
                  <Card.Body>
                    {obcanskaZnanost.map((item, index) => {
                      const total = obcanskaZnanost.reduce((sum, p) => sum + (p.value || p.Value || 0), 0);
                      const percentage = total > 0 ? Math.round(((item.value || item.Value || 0) / total) * 100) : 0;
                      
                      // Color coding
                      const label = (item.label || item.Label || "").toLowerCase();
                      const color = label.includes("čanska") || label.includes("citizen") ? "#006a8e" : "#757575";
                      
                      return (
                        <div key={index} className="mb-3">
                          <div className="d-flex justify-content-between mb-2">
                            <span style={{ fontWeight: "500" }}>{item.label || item.Label}</span>
                            <span>
                              <strong>{item.value || item.Value}</strong> <span className="text-muted">({percentage}%)</span>
                            </span>
                          </div>
                          <ProgressBar
                            now={percentage}
                            style={{ height: "30px", backgroundColor: "#e0e0e0" }}
                          >
                            <div
                              style={{
                                width: `${percentage}%`,
                                backgroundColor: color,
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontWeight: "700",
                                fontSize: "1rem"
                              }}
                            >
                              {percentage}%
                            </div>
                          </ProgressBar>
                        </div>
                      );
                    })}
                  </Card.Body>
                </Card>
              </Col>
            )}
          </Row>
        </>
      )}
    </Container>
  );
};

export default Dashboard;
